import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { delay, SharedService } from '../../shared';
import { CannabisJSON } from '../data';
import { CannabisQuestion, CannabisSection, showQuestionForPartner } from '../shared';

@Component({
    selector: 'questions-info',
    templateUrl: "./questions-info.component.html",
    styleUrls: ["./questions-info.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class QuestionsInfoComponent implements OnInit, AfterViewInit {
    @Input() partnerName: string = "";
    @Input() sectionNumber: number;
    @Input() questionNumber: number;

    displayNumber: number = 0;
    CannabisJSON: CannabisSection[] = [];

    constructor(private sharedService: SharedService) {
    }

    ngOnInit(): void {
        this.CannabisJSON = this.getCannabisJSON();
    }

    ngAfterViewInit() {
        this.navigateToBlockId(this.sectionNumber, this.questionNumber);
        setTimeout(() => {
            this.navigateToBlockId(this.sectionNumber, this.questionNumber);
        }, 100);
    }

    getCannabisJSON() {
        let CannibsJSON: CannabisSection[] = [];
        for (var p = 0; p < CannabisJSON.length; p++) {
            const section = CannabisJSON[p];
            let questions: CannabisQuestion[] = [];
            for (var i = 0; i < section.questions.length; i++) {
                const quest = section.questions[i];
                if (this.showQuestion(quest)) {
                    questions.push(quest);
                }
            }
            section.questions = [...questions];
            CannibsJSON.push(section);
        }
        return CannibsJSON;
    }

    showQuestion(quest: CannabisQuestion) {
        return showQuestionForPartner(quest, this.partnerName);
    }

    navigateToBlockId(sectionId, questionId) {
        const elmId = `section_${sectionId}_question_${questionId}_info`;
        const elm: HTMLElement = document.getElementById(elmId) as HTMLElement;
        if (elm) {
            //const formBoxes = document.getElementsByClassName("jsPanel-content")[0] as HTMLElement;
            //formBoxes.scrollTo(
            //    {
            //        top: elm.offsetTop,
            //        behavior: "smooth"
            //    }
            //)
            elm.scrollIntoView({ behavior: "smooth" });
        }
    }

    getQuestionNumber(section: CannabisSection, question: CannabisQuestion, pIndex: Number, index: Number) {
        this.displayNumber = this.sharedService.getQuestionNumber(section, question, pIndex, index, this.displayNumber);
        return this.displayNumber;
    }

}
